<template >
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  
  name: "app",
  data: () => ({
           
           
        }),
  components: {},
    created: function() {
    
  },
  mounted: function () {

  }
};
</script>

<style lang="scss" src="./assets/scss/main.scss"></style>
